import React from 'react';
import AdminDashboard from '../components/Admin_Dashboard';

const AdminDashboardPage: React.FC = () => <AdminDashboard />;

export default AdminDashboardPage;
